import { normalizeStrokeWidth } from './utils/normalizeStrokeWidth.js';
import { jsxs, jsx } from 'react/jsx-runtime';
import { SVG } from '../utils/style.svg.js';

const PM2LibraryIcon = ({
  color = "currentColor",
  strokeWidth = 1.5,
  ...svgProps
}) => {
  return /*#__PURE__*/jsxs(SVG, {
    xmlns: "http://www.w3.org/2000/svg",
    ...svgProps,
    viewBox: "0 0 21.083 18.631",
    fill: "none",
    stroke: color,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: normalizeStrokeWidth(strokeWidth, 18.631),
    children: [/*#__PURE__*/jsx("path", {
      d: "m18.435 16.884a1.662 1.662 0 0 1 -1.326-1.916l.312-3.57a1.662 1.662 0 0 1 1.638-1.656 1.662 1.662 0 0 1 1.326 1.915l-.312 3.57a1.662 1.662 0 0 1 -1.638 1.657z"
    }), /*#__PURE__*/jsx("path", {
      d: "m18.748 9.31a8.643 8.643 0 0 0 -8.412-8.81 8.644 8.644 0 0 0 -8.412 8.81"
    }), /*#__PURE__*/jsx("path", {
      d: "m2.649 16.885a1.662 1.662 0 0 0 1.326-1.914l-.312-3.57a1.662 1.662 0 0 0 -1.638-1.657 1.662 1.662 0 0 0 -1.325 1.916l.312 3.571a1.662 1.662 0 0 0 1.638 1.655z"
    }), /*#__PURE__*/jsx("path", {
      d: "m7.542 5.447h2.021v12.525h-2.021z"
    }), /*#__PURE__*/jsx("path", {
      d: "m10.166 7.052 1.996-.316 1.743 11.007-1.996.316z"
    })]
  });
};

export { PM2LibraryIcon };
//# sourceMappingURL=library.js.map
